import { FC } from 'react';

import { FormTabs } from 'components';

import { LegalClientBranchSectionsProps } from './types';
import { useLegalClientBranchSections } from './useLegalClientBranchSections';

export const LegalClientBranchSections: FC<LegalClientBranchSectionsProps> = (
  props
) => {
  const { tabs } = useLegalClientBranchSections(props);

  return <FormTabs tabs={tabs} />;
};
